import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum } from '@systemeio/ui';
import { CouponInterface } from 'modules/coupons/types/coupon-interface';
import { useCustomerCoupons } from 'modules/funnels/funnel/components/step-configuration-tab/coupon-selector/hooks/use-coupons';
import { useEffect, useState } from 'react';
interface useAvailableCouponsProps {
  currency: CurrencyEnum;
  shouldFetch?: boolean;
  initialData?: CouponInterface[];
}
export function useAvailableCoupons(t0) {
  const $ = _c(6);
  const {
    currency,
    shouldFetch,
    initialData
  } = t0;
  const [availableCoupons, setAvailableCoupons] = useState(undefined);
  const {
    coupons
  } = useCustomerCoupons(currency, shouldFetch);
  let t1;
  let t2;
  if ($[0] !== coupons || $[1] !== initialData) {
    t1 = () => {
      if (coupons) {
        if (initialData) {
          const initialDataIds = initialData.map(_temp);
          const filteredCoupons = coupons.filter(coupon_0 => !initialDataIds.includes(coupon_0.id));
          setAvailableCoupons(filteredCoupons);
        } else {
          setAvailableCoupons(coupons);
        }
      }
    };
    t2 = [coupons, initialData];
    $[0] = coupons;
    $[1] = initialData;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== availableCoupons) {
    t3 = {
      availableCoupons,
      setAvailableCoupons
    };
    $[4] = availableCoupons;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(coupon) {
  return coupon.id;
}